module.exports = __webpack_public_path__ + "static/media/ic-remove-hover.e6cd3041.svg";